<div
  [style.background-image]="
    isWalletApp
      ? 'url(/assets/media/bg/wallet-auth-background.png)'
      : 'url(/assets/media/bg/auth-background.png)'
  "
  style="
    min-height: 100%;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: white;
  "
>
  <div
    class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1"
    id="kt_login"
  >
    @if (features.i18n) {
      <kt-language-selector
        [isWalletApp]="isWalletApp"
        class="ml-auto me-4 register-language-selector"
      ></kt-language-selector>
    }
    <div
      class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--hor-tablet-and-mobile"
    >
      <!--begin::Content-->
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper pt-0"
      >
        <router-outlet></router-outlet>
      </div>
      <!--end::Content-->
    </div>
  </div>
</div>
